export default __webpack_public_path__ + "static/media/Contact.8916e112.png";